import React, { useCallback, useEffect, useRef, useState } from "react";
import cn from "classnames";
import { Link } from "react-router-dom";
import { useIntl } from "react-intl";

import { Card, Gap, LoaderBottom, LoaderTop } from "../../../../../components/PlanCard/styles";
import { StyledTitle, StyledTopBar } from "../../../../../components/PlanCard/TopBar/styles";
import { coverHost } from "../../../../../paths";
import { defaultCover, isMobile } from "../../../../../../common/parameters";
import { StyledLastRow } from "../../../../../components/PlanCard/LastRow/styles";
import { StyledQuickButtons } from "../../../../../components/PlanCard/QuickButtons/styles";
import Tooltip from "../../../../../components/Tooltip";
import routing from "../../../../../routing";
import Icon from "../../../../../icon";

import { City, WantedVoices } from "./styles";
import messages from "./messages";
import { IProps } from "./interfaces";
import { getPhotoURL } from "../../../dashboard/Meta/Additional/PhotoGaleryEditor/utils";
import { CHOIR_VOICES } from "../../../../../../common/types/choir/meta/general";

const ChoirCard = ({ choir }: IProps) => {
    const imgAR = useRef<SVGSVGElement>(null);
    const card = useRef<HTMLDivElement>(null);
    const { formatMessage } = useIntl();
    const [mobilScroll, setMobileScroll] = useState(false);
    const [hover, setHover] = useState(false);
    const [imageHeight, setImageHeight] = useState<number | null>(null);
    const handleResize = useCallback(() => {
        if (imgAR.current) {
            setImageHeight(imgAR.current.getBoundingClientRect().width * (720 / 1280));
        }
    }, [setImageHeight, imgAR]);
    const handleScroll = useCallback(() => {
        if (!card.current) return;
        const scrollTop = (document.scrollingElement || document.documentElement).scrollTop;
        const height = window.innerHeight;
        const cardHeight = card.current.getBoundingClientRect().height;
        if (card.current.offsetTop - scrollTop > -30 && card.current.offsetTop - scrollTop + cardHeight + 30 < height) {
            setMobileScroll(true);
        } else {
            setMobileScroll(false);
        }
    }, [setMobileScroll, card]);
    useEffect(() => {
        if (isMobile) {
            window.addEventListener("scroll", handleScroll);
        }
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleResize);
        }
    }, [])

    return (
        <Card
            ref={card}
            onMouseMove={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
        >
            {choir ? (
                <StyledTopBar>
                    <StyledTitle>
                        <span title={choir.name}>{choir.name}</span>
                    </StyledTitle>
                </StyledTopBar>
            ) : (
                <LoaderTop />
            )}
            <div
                className={"Image"}
                style={{
                    ...(choir ? {
                        backgroundImage: `url(${getPhotoURL(choir.meta.additional.photos[0]) || `${coverHost}${defaultCover}-en.jpg`})`,
                    } : {
                        background: `#CCCCCC`
                    })
                }}
            >
                <svg
                    width="100%"
                    viewBox="0 0 128 72"
                    ref={imgAR}
                    style={{ height: imageHeight || "auto" }}
                />
                {choir && (
                    <StyledQuickButtons tinyMobile={false} tiny={false} className={cn((hover || mobilScroll) && "Show")}>
                        <Tooltip key="view" label={formatMessage(messages.view)} light>
                            <Link to={`/${routing.choir}/${choir._id}`}>
                                <Icon i="view" />
                            </Link>
                        </Tooltip>
                    </StyledQuickButtons>
                )}
            </div>
            {choir ? (
                <StyledLastRow tiny={false}>
                    <City>{choir.meta.general.rehearsalLocation?.data?.locality}</City>
                    <WantedVoices>{CHOIR_VOICES.filter(cv => choir.meta.general.wantedVoices.includes(cv)).join(", ")}</WantedVoices>
                </StyledLastRow>
            ) : (
                <LoaderBottom>
                    <Gap></Gap>
                </LoaderBottom>
            )}
        </Card>
    );
};

export default ChoirCard;
